import * as React from 'react';
import * as styles from './styles.css';

export interface IMapSimilarNewbuildingBalloonProps {
  ballonId?: string;
  imageUrl: string | null;
  onClick?: () => void;
  minPrice: string | null;
  roominess: string | null;
  title: string;
  url: string;
}

export function MapSimilarNewbuildingBalloon(props: IMapSimilarNewbuildingBalloonProps) {
  const { ballonId, roominess, title, imageUrl, minPrice, url, onClick } = props;

  return (
    <div id={ballonId} className={styles['balloon']}>
      {imageUrl && (
        <a
          className={styles['icon']}
          target={'_blank'}
          rel="noreferrer"
          href={url}
          title={title}
          onClick={onClick}
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}
      <div className={styles['content']}>
        <a className={styles['title']} onClick={onClick} target={'_blank'} rel="noreferrer" href={url}>
          {title}
        </a>
        {roominess && minPrice && (
          <div>
            <span className={styles['min-price']}>{minPrice}</span>
            <span className={styles['roominess']}>{roominess}</span>
          </div>
        )}
      </div>
    </div>
  );
}
